/**
 * SDL Physics Constants
 * These values must match the prototype exactly
 */
export const SDL_PHYSICS_DEFAULTS = {
    gravity: 30,
    throwPower: 35,
    baseForward: 5,
    diceDamping: 0.2,
    wallBounce: 0.3,
    floorBounce: 0.15,
    holdHeight: 4,
    energyGain: 0.3,
    maxEnergy: 100,
};
export const SDL_COLLISION_GROUPS = {
    DICE: 1 << 0,
    TABLE: 1 << 1,
    WALL: 1 << 2,
    BILL: 1 << 3,
    PROP: 1 << 4,
    DEFAULT: 1 << 5,
};
export const SDL_COLLISION_MASKS = {
    DICE: SDL_COLLISION_GROUPS.TABLE | SDL_COLLISION_GROUPS.WALL | SDL_COLLISION_GROUPS.DICE | SDL_COLLISION_GROUPS.PROP,
    TABLE: SDL_COLLISION_GROUPS.DICE | SDL_COLLISION_GROUPS.BILL,
    WALL: SDL_COLLISION_GROUPS.DICE,
    BILL: SDL_COLLISION_GROUPS.TABLE,
    PROP: SDL_COLLISION_GROUPS.DICE,
    DEFAULT: 0xffffffff,
};
//# sourceMappingURL=physics.js.map